module.exports = __webpack_public_path__ + "static/media/english-flag.d44ecbcf.svg";